export default {"src":"/_next/static/media/projector.3cb7851a.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};